export interface Ball {
  x: number;
  y: number;
  vx: number;
  vy: number;
  number: number;
  pocketed: boolean;
}

export interface PoolGame {
  balls: Ball[];
  cueBall: Ball;
  aimAngle: number;
  power: number;
  turn: 1 | 2;
  inMotion: boolean;
  foul: boolean;
  winner: number | null;
  message: string;
  placed: boolean;
}

export const TABLE_W = 600;
export const TABLE_H = 300;
export const RAIL = 30;
export const BALL_R = 8;
export const POCKET_R = 18;

export const POCKETS = [
  { x: RAIL, y: RAIL },
  { x: TABLE_W / 2, y: RAIL - 4 },
  { x: TABLE_W - RAIL, y: RAIL },
  { x: RAIL, y: TABLE_H - RAIL },
  { x: TABLE_W / 2, y: TABLE_H - RAIL + 4 },
  { x: TABLE_W - RAIL, y: TABLE_H - RAIL },
];
